/* eslint-disable import/prefer-default-export */
export { default as Hubspot } from "./hubspot";
